// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"f33d1c0b","254":"bb2f5f5a","343":"008b9cd8","544":"7e92d07a","631":"dff314f8","715":"470c4f8c","757":"7a008b08","787":"e232877a","790":"56214610","896":"12af350d"}[chunkId] + ".chunk.js";
};